import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { yaCounterByHostname } from '@/shared/lib/helpers/yandexCounter';

export default function usePwa() {
	const store = useStore();
	const showInstallPrompt = ref(false);

	const installPrompt = computed({
		get() {
			return store.state.pwaEvent;
		},
		set(val) {
			store.commit('SET_PWA_EVENT', val);
		},
	});

	watch(() => installPrompt.value, (iPrompt) => {
		showInstallPrompt.value = !!iPrompt;
	}, { immediate: true });

	function installPWA() {
		if (installPrompt.value) {
			installPrompt.value.prompt();
			installPrompt.value.userChoice.then((choiceResult) => {
				console.log('choise:', choiceResult);
				if (choiceResult.outcome === 'accepted') {
					// window.dispatchEvent(new CustomEvent('onUserInstalledPWA', { detail: { pwaInstalled: true } }));
					installPrompt.value = null;
					console.log('Пользователь установил PWA');
					window.ym(yaCounterByHostname(), 'reachGoal', 'install_app_contract');
					// console.log('pwainstalled usePwa.js');
				}
			});
		}
	}

	return { installPWA, showInstallPrompt };
}
